import FlowFieldInputView from "./FlowFieldInputView";

function FlowFieldInput({ flowField, value, onChange, disabled = false }) {
  return (
    <FlowFieldInputView
      flowField={flowField}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export default FlowFieldInput;
